import $ from 'jquery';

let splitScreenMixin = {
	methods: {
    getOfflineThat(webrtcInforms, cameraInfo) {
      return {
        $parent : null,
        $store : null,
        cameraInfo : cameraInfo,
        webrtcInforms: webrtcInforms,
        playPoint : null,
      }
    },
		getSplitList() { 
			// 분할 화면 리스트 데이터 받아오기
			this.loading = true;
      let params = {};
      this.networkController.getPrivateUserSplitScreenList(params)
      .then(async (res) => {
        // console.log('%cFetch Split Screen List\n', "color:#008DD0;", res.data);
        this.ulog('Fetch Split Screen List', res.data)
        this.splitScreenList = res.data;
        this.$emit('updateSplitScreenList', res.data);
				this.$store.commit('setAllPrivateSplitScreenList', res.data);
				if(this.splitScreenList.length > 0) {
					if(this.$store.state.userData.selectedSplitScreen) {
						this.selectedSplitScreen = this.$store.state.userData.selectedSplitScreen;
					} else {
						this.selectedSplitScreen = this.splitScreenList[0].splitName;
					}
				} else {
					this.goNewSplitScreen();
				}
      }).catch(error => { });
    },
		getSplitListCameras(value) { //선택된 분할화면리스트의 카메라 가져오기 
			this.loading = true;
      // 만들어져있던 player들을 dispose
		  for(let i = 0; i < this.players.length; i++) {
				// 중간에 스트리밍 되지 않은 비디오는 dispose 하면 에러가 나기 때문에 if문으로 처리
        if(this.players[i] != undefined && this.players[i].isDisposed_ != true) 
      	  this.players[i].dispose();
      }
      this.ulog('getSplitListCameras', this.players, this.selectedSplitScreen);

      let params = {};
      const index = this.splitScreenList.findIndex(r => r.splitName == this.selectedSplitScreen);
      this.networkController.getPrivateUserSplitScreen(params, this.splitScreenList[index].id)
      .then((res) => {
        this.ulog('Current Split Screen', res.data)
        this.splitScreenId = res.data.id;
        this.splitScreenCameraList = res.data.cameras;
        for (let i = 0; i < this.splitScreenCameraList.length; ++ i) {
          const item = this.splitScreenCameraList[i];
          this.streamingCount = 0;
          if (item.webrtc) this.getRTCPeerConStream(item, index);
          else this.getAllStreamingUrl(item, index);
        }
        if(value == 0) this.changeViewCount(res.data);
				this.loading = false;
      }).catch(error => {
				this.loading = false;
				console.log(error)
        console.log("get split list cameras error");
			});
    },
		deleteSplitScreen(id) { 
			// 분할화면 삭제
			this.$vloading.show();
      let params = {};
      this.networkController.deletePrivateUserSplitScreen(params, id)
      .then(async (res) => {
        console.log("Delete success");
				this.$vloading.hide();
				this.showToastMessage(this.tmb('requestSuccess'));
        await this.$store.commit('setSelectedSplitScreen', null);
        this.getSplitList();
      }).catch(error => {
				this.$vloading.hide();
			})
    },
		showMenu(index, total) {
      if(index == null) {
        for(let i=0; i<total; i++) {
          $("#camera_select_menu" + i).css({'display': 'none'});
				}
      }
      for(let i=0; i<total; i++) {
        if(index != i) { //누른 비디오의 메뉴 제외 모두 display none
          $("#camera_select_menu" + i).css({'display': 'none'});
				} else { //누른 비디오의 메뉴 보여주거나 없애기
          if(document.getElementById("camera_select_menu" + i).style.display == 'none' ||
            document.getElementById("camera_select_menu" + i).style.display == '') {
            document.getElementById("camera_select_menu" + i).style.display = 'block';
					} else { 
            document.getElementById("camera_select_menu" + i).style.display = 'none';
					}
				}
      }
    },
		hideMenu() {
      this.showMenu(null, this.viewCount);
    },
    splitscreenNameFormat(name) {
      if(name.includes('名称未設定')) return name.substring(0,5);
      else return name;
    },
    async restartPlayer(index) {
			console.log('restartPlayer', index);
      if (this.players[index]) {
        let streamData = this.splitScreenCameraList[index];
        let params = {};
        await this.networkController.getHlsStreamingUrl(params, streamData.streamName, '', '')
          .then(async (res) => {
            this.stopProgressBar(`example-${this.viewCount}-progress${streamData.index}`);
            this.players[index].src({
              src: res.data.hlsstreamingSessionURL,
              type: 'application/x-mpegURL'
            });
						this.players[index].load();
            this.players[index].play();
          }).catch(error => { });
      }
    },
		initializePausePlayInterval() {
      this.pausePlayInterval = setInterval(() => {
        for (let i = 0; i < this.players.length; i++) {
          if (this.players[i] && !this.players[i].paused()) {
            this.players[i].pause();
            this.players[i].play();
          }
        }
      }, 10000);
    },
	}
}
export default splitScreenMixin;